export default __webpack_public_path__ + "static/media/75.1286e068.jpg";